export default __webpack_public_path__ + "static/floor1_image1-pc-360f082c4f1734474196d4aaa6865ed0.png";